import { ConvertUrlToFile } from '@/common/utils/ConvertUrlToFile';
import { fetchApi } from '@/config/axiosSetting';
import {
  PostAdjusterAttachedImagesPropsType,
  PostAdjusterAttachedImagesQueryParamsType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/postDamagedAdjusterAttachedImages/postAdjusterAttachedImagesQuery.type';
import { AdditionalApiUrlCreator } from '@/modules/adjusterReportModules/IncidentParticipants/utils/AdditionalApiUrlCreator';

export const postAdjusterAttachedImagesFunction = ({
  id,
  damagedId,
  type,
  fileType,
  data,
}: PostAdjusterAttachedImagesQueryParamsType &
  PostAdjusterAttachedImagesPropsType) => {
  const postData = new FormData();
  const image = ConvertUrlToFile(data.image, 'image', 'image');
  postData.append('image', image);

  const url = AdditionalApiUrlCreator({
    id,
    TabType: type,
    userType: fileType,
  });

  return fetchApi({
    method: 'post',
    url,
    data: postData,
    params: fileType === 'damaged' ? { damaged_id: damagedId } : undefined,
  });
};
